import { render, staticRenderFns } from "./DeclineAssetApprovalRequest.vue?vue&type=template&id=096ee87a"
import script from "./DeclineAssetApprovalRequest.vue?vue&type=script&lang=js"
export * from "./DeclineAssetApprovalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports